/* src/app/@framework/components/FormModal/form-modal.component.less */
:host ::ng-deep .p-sidebar-header {
  justify-content: space-between;
}
:host ::ng-deep .p-sidebar-header .zapp-icon i {
  cursor: pointer;
}
/*# sourceMappingURL=form-modal.component.css.map */
